import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Homepage/Components/AdminNav';
import Vendors from './Components/Vendors/Vendors';
import Products from './Components/Products/Products';
import Orders from './Components/Orders/Orders';
import Messages from './Components/Messages/Messages';
import { ExpandCategoriesIcon, CollapseCategoriesIcon } from '../../Constants/Icons';
import { useLocation } from 'react-router-dom';
import { fetchVendors, fetchProducts } from '../API_Handler';
const Profile = () => {
    const location = useLocation();

    const [vendorsList, setVendorsList] = useState({});
    const [productsList, setProductsList] = useState({});
    const [loading, setLoading] = useState(false);

    const buttonLabels = [
        "Vendors",
        "Products",
        "Orders",
        "Messages",
    ];

    const [navigateTo, setNavigateTo] = useState("");

    useEffect(() => {
        async function initialLoad() {
            setLoading(true);
            const segments = location.pathname.split("/");
            const profileIndex = segments.indexOf("profile");
            if (profileIndex !== -1 && profileIndex + 1 < segments.length) {
                const category = segments[profileIndex + 1];
                switch (category) {
                    case "vendors":
                        setSelectedCategory("Vendors");
                        break;
                    case "products":
                        setSelectedCategory("Products");
                        break;
                    case "orders":
                        setSelectedCategory("Orders");
                        break;
                    case "messages":
                        setSelectedCategory("Messages");
                        break;
                }
                const additionalSegment = segments.slice(profileIndex + 2).join('/');
                setNavigateTo(additionalSegment);
            }
            try {
                const vendors = await fetchVendors();
                setVendorsList(vendors);
            } catch (error) {
                console.error("Error fetching vendors:", error);
            }
            try {
                const products = await fetchProducts();
                setProductsList(products);
            } catch (error) {
                console.error("Error fetching products:", error);
            }
            setLoading(false);
        }
        initialLoad();
    }, []);

    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState('Vendors');

    const handleCategoryChange = (category) => {
        navigate(`/admins/profile/${category}`);
        setSelectedCategory(category);
    };

    const renderComponent = () => {
        switch (selectedCategory) {
            case 'Vendors':
                return <Vendors vendorsList={vendorsList} productsList={productsList} />
            case 'Products':
                return <Products productsList={productsList} scrollTo={navigateTo} />;
            case 'Orders':
                return <Orders />;
            case 'Messages':
                return <Messages />;
            default:
                return <Vendors allMode={false} />
        }
    };

    const [categoriesExpanded, setCategoriesExpanded] = useState(true);

    const handleExpandedClick = (button) => {
        setCategoriesExpanded(!categoriesExpanded);
    };

    return (
        <div className="min-h-screen w-full flex flex-col bg-marketplaceBackground">
            <Navbar />
            <div className="flex flex-row flex-grow">
                {!categoriesExpanded && (
                    <button className="mt-2 text-white rounded-r-full min-w-12 min-h-10 max-h-10 flex items-center justify-center bg-exploreCategoriesBackground"
                        onClick={() => handleExpandedClick()}>
                        <ExpandCategoriesIcon />
                    </button>
                )}

                {categoriesExpanded && (
                    <div className="w-40 3xl:w-[25rem] flex-none flex flex-col items-start bg-gradient-to-b from-[#4c0b35] to-[#7e1a5a]">

                        <div className="mt-2 w-full flex justify-end">
                            <button className="text-white rounded-l-full min-w-12 min-h-10 max-h-10 flex items-center justify-center bg-exploreCategoriesBackground"
                                onClick={() => handleExpandedClick()}>
                                <CollapseCategoriesIcon />
                            </button>
                        </div>
                        <div className="mt-4 w-full">
                            {buttonLabels.map((label, index) => (
                                <button
                                    key={index}
                                    className={`text-exploreCategoriesText ${selectedCategory === label ? 'bg-exploreCategoriesBackground text-exploreCategoriesText' : 'bg-clear'} 
                                    ${selectedCategory === label ? 'font-semibold' : 'font-normal'}
                                    text-lg 3xl:text-2xl mt-2 py-2 px-6 w-full`}
                                    onClick={() => handleCategoryChange(label)}
                                >
                                    {label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
                {loading ?
                    <div className="w-full h-screen flex flex-col items-center justify-center">
                        <div className="spinner-border" role="status"> </div>
                        <p className="mt-[12px] text-center font-proximanova text-[18px] text-[#505050] font-[400]">Loading...</p>
                    </div>
                    :
                    <div className="mx-8 mt-8 flex flex-col flex-grow">
                        {renderComponent()}
                    </div>
                }
            </div>
        </div >
    );
};

export default Profile;